import type { ElementType } from 'react'

import cn from '@components/utils/cn'

export type PageHeaderNavItem = { label: string; href: string; current?: boolean; count?: number; legacy?: boolean }

export type PageHeaderNavProps = {
  items: PageHeaderNavItem[]
  ariaLabel: string
  className?: string
  linkComponent?: ElementType<{ href: string; className?: string; 'aria-current'?: 'page' }>
}

export type PageTabs = { label: string; items: PageHeaderNavItem[] }

export function PageHeaderNav({ items, ariaLabel, className, linkComponent: LinkComponent = 'a' }: PageHeaderNavProps) {
  return (
    <nav aria-label={ariaLabel} className={className}>
      <ul className="tw:m-0 tw:flex tw:p-0">
        {items.map(({ legacy, ...item }) => {
          const ItemLink = legacy ? 'a' : LinkComponent
          return (
            <li key={item.href} className="tw:list-none">
              <ItemLink
                href={item.href}
                aria-current={item.current ? 'page' : undefined}
                className={cn(
                  'tw:-mb-px tw:flex tw:items-center tw:gap-2 tw:border-b-2 tw:px-5 tw:py-3 tw:text-sm tw:font-medium tw:no-underline',
                  'tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-primary-500',
                  item.current
                    ? 'tw:border-primary-600 tw:text-primary-700'
                    : 'tw:border-transparent tw:text-gray-cool-600 tw:hover:border-gray-cool-300 tw:hover:text-gray-cool-900'
                )}
              >
                {item.label}
                {item.count ? ' ' : null}
                {item.count ? (
                  <span className="tw:inline-flex tw:min-w-5 tw:items-center tw:justify-center tw:rounded-full tw:bg-red-600 tw:px-1.5 tw:text-xs tw:font-semibold tw:text-white">
                    {item.count}
                  </span>
                ) : null}
              </ItemLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
